import { Injectable } from '@angular/core';
import { GeneratedClientManagerService } from '@cloud-twin-v2/generated/generated-client-manager.service';
import {
  AttributeClient,
  AttributeDto,
  DateRangeDto
} from '@cloud-twin-v2/generated/simulation.generated.client';
import { GetCacheOpts } from '@common-modules/cache/http-cache/http-cache.client';
import { DateHelperService } from '@common-modules/shared/helpers/date-helper.service';
import { asEnumerable } from 'linq-es2015';
import { Observable, forkJoin, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AttributesMetadata } from '../models/element-type-categories.dto';
import { MasterOperatorConnectSettings } from '../models/master-operator-connect-settings';

@Injectable()
export class ScenarioInfoService extends GeneratedClientManagerService {
  expiration: GetCacheOpts = { expiration: 'default', reload: true };

  private _attributesClient: AttributeClient;

  constructor(private _dateHelperService: DateHelperService) {
    super();
    this._attributesClient = new AttributeClient(this.httpClient, this.baseUrl);
  }

  getScenarioAttributesInfo(
    snapshotId: string,
    scenarioId: string
  ): Observable<AttributesMetadata> {
    const context = this.buildHttpContext();
    // const metadata$ = this._attributesClient
    //   .getAttributesMetadata(snapshotId, scenarioId, context)
    //   .pipe(
    //     map((metadata: ElementTypeCategoriesDto[]) => {
    //       return new AttributesMetadata({
    //         snapshotId,
    //         scenarioId,
    //         elementTypesCategories: metadata,
    //       });
    //     })
    //   );
    return of(null); // metadata$;
  }

  getLayerAttributes(
    snapshotId: string,
    scenarioId: string,
    networkElementId: string,
    step: Date,
    category: string
  ): Observable<AttributeDto[]> {
    const context = this.buildHttpContext();

    const startDate = new Date(step);
    const endDate = new Date(step);
    const attributeNames = null;

    const attributes$ = this._attributesClient.getAttributeValues(
      snapshotId,
      scenarioId,
      networkElementId,
      startDate,
      endDate,
      category,
      attributeNames,
      context
    );

    return attributes$;
  }

  getLayerAttributesForChart(chartParams: any): Observable<AttributeDto[]> {
    const context = this.buildHttpContext();

    const attributes$ = this._attributesClient.getAttributeValues(
      chartParams.snapshotId,
      chartParams.scenarioId,
      chartParams.networkElementId,
      chartParams.startDate,
      chartParams.endDate,
      chartParams.category,
      chartParams.attributeNames,
      context
    );

    return attributes$;
  }

  getSimulationScenarioDateRange(snapshotId: string, scenarioId: string): Observable<DateRangeDto> {
    //const context = this.buildHttpContext();
    // const dateRange$ = this._attributesClient.getAttributeDateRange(
    //   snapshotId,
    //   scenarioId,
    //   context
    // );
    // return dateRange$;
    return of(null);
  }

  getDateRangesByMultiplesScenarios(
    settings: MasterOperatorConnectSettings[]
  ): Observable<DateRangeDto> {
    const dates$ = settings.map((setting) =>
      this.getSimulationScenarioDateRange(setting.snapshotId, setting.scenarioId)
    );

    return forkJoin(dates$).pipe(
      map((dates) => {
        const minStartDate = new Date(
          asEnumerable(dates)
            .Select((x) => x.startDate)
            .Min()
        );
        const maxEndDate = new Date(
          asEnumerable(dates)
            .Select((x) => (x.endDate ? x.endDate : new Date()))
            .Max()
        );

        const steps = asEnumerable(dates.map((x) => x.steps))
          .SelectMany((steps) =>
            steps.map((step) => this._dateHelperService.fromApiFormat(step.toString(), false))
          )
          .Distinct((step) => step.toString())
          .ToArray();

        return new DateRangeDto({ startDate: minStartDate, endDate: maxEndDate, steps: steps });
      })
    );
  }
}
